import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useFood } from "./FoodLayout";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import InstituteMap from "@/components/InstituteMap";

export default function Contact() {
  const data = useFood();
  const inst = data.institute || {};
  return (
    <div data-testid="ft-contact">
      <PageHero eyebrow="Get in touch" title="Reach the campus" />
      <PageBody>
        <div className="grid md:grid-cols-3 gap-5">
          <div className="bg-white rounded-lg p-6 ring-1 ring-[#E6E2D6]">
            <Phone className="text-[#1F6B3F]" size={22} strokeWidth={1.5} />
            <h3 className="mt-2 font-serif text-lg">Call</h3>
            <ul className="mt-3 space-y-1.5 text-sm text-[#0F1F17]">
              {inst.admission_phone && <li><a href={`tel:${inst.admission_phone.replace(/\s+/g, "")}`} className="hover:text-[#F4751F]">{inst.admission_phone}</a> · Admissions</li>}
              {inst.contact_phone && <li><a href={`tel:${inst.contact_phone.replace(/\s+/g, "")}`} className="hover:text-[#F4751F]">{inst.contact_phone}</a> · Office</li>}
            </ul>
          </div>
          <div className="bg-white rounded-lg p-6 ring-1 ring-[#E6E2D6]">
            <Mail className="text-[#1F6B3F]" size={22} strokeWidth={1.5} />
            <h3 className="mt-2 font-serif text-lg">Email</h3>
            <ul className="mt-3 space-y-1.5 text-sm">
              {inst.email && <li><a href={`mailto:${inst.email}`} className="hover:text-[#F4751F]">{inst.email}</a></li>}
            </ul>
          </div>
          <div className="bg-white rounded-lg p-6 ring-1 ring-[#E6E2D6]">
            <MessageCircle className="text-[#1F6B3F]" size={22} strokeWidth={1.5} />
            <h3 className="mt-2 font-serif text-lg">WhatsApp</h3>
            <p className="mt-3 text-sm">
              {inst.whatsapp_phone ? (
                <a href={`https://wa.me/${inst.whatsapp_phone.replace(/[^0-9]/g, "")}`} target="_blank" rel="noopener noreferrer" className="text-[#1F6B3F] hover:text-[#13532E]">Start chat →</a>
              ) : <span className="text-[#4D5A52]">Not configured yet</span>}
            </p>
          </div>
        </div>

        <div className="mt-8 bg-[#1F6B3F] text-white rounded-lg p-7">
          <MapPin className="text-[#F4751F]" size={22} strokeWidth={1.5} />
          <h3 className="mt-2 font-serif text-xl">Campus</h3>
          <p className="mt-2 text-sm text-white/90">
            {[inst.address1, inst.address2, [inst.city, inst.pincode && `– ${inst.pincode}`].filter(Boolean).join(" "), inst.state, inst.country || "INDIA"].filter(Boolean).join(", ") || "Address will be available soon."}
          </p>
        </div>

        <div className="mt-6">
          <div className="text-xs uppercase tracking-[0.2em] text-[#1F6B3F] font-semibold mb-3">Find us on map</div>
          <InstituteMap
            latitude={inst.latitude}
            longitude={inst.longitude}
            address={[inst.address1, inst.city, inst.state, inst.country].filter(Boolean).join(", ")}
            testid="food-contact-map"
            className="w-full aspect-[16/9] rounded-lg overflow-hidden ring-1 ring-black/10 bg-slate-100"
          />
        </div>
      </PageBody>
    </div>
  );
}
